import { Easing, interpolate, useCurrentFrame } from 'remotion';

// Types
import type { MaskRevealTextProps } from '../../types';

// Constants
import { CLAMP_BOTH } from '@/constants';
import { ANIMATION_DURATIONS } from '../../constants';

// Utils
import { combineClasses } from '@/utils';

export const MaskRevealText = ({
  children,
  animationDelay = 0,
  className,
  style,
}: MaskRevealTextProps) => {
  const frame = useCurrentFrame();

  // Bezier easing for smooth reveal
  const easedReveal = Easing.bezier(
    0.25,
    0.1,
    0.25,
    1,
  )(
    interpolate(
      frame,
      [animationDelay, animationDelay + ANIMATION_DURATIONS.maskReveal],
      [0, 1],
      CLAMP_BOTH,
    ),
  );

  // Animation values
  const translateY = interpolate(easedReveal, [0, 1], [20, 0]);
  const opacity = interpolate(easedReveal, [0, 1], [0, 1]);
  const clipPath = interpolate(easedReveal, [0, 1], [0, 100]);

  return (
    <span
      className={combineClasses('inline-block align-top', className)}
      style={{
        ...style,
        clipPath: `inset(${100 - clipPath}% 0 0 0)`,
        transform: `translateY(${translateY}px)`,
        opacity,
      }}
    >
      {children}
    </span>
  );
};
